import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";
const ProtectedRoute = ({ allowedTypes, children }) => {
  const { user } = useContext(GlobalContext);

  const userType =
    user?.us_type || JSON.parse(sessionStorage.getItem("user"))?.us_type || "G";

  if (!allowedTypes.includes(userType)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
